import React, { useState, useRef, useEffect } from 'react';
import AspectDropdown from './AspectDropdown';

interface ToolbarProps {
  aspectRatio: string;
  onAspectChange: (ar: string) => void;
  onAddCaption: () => void;
  onAddEmoji: () => void;
  onAddImage: () => void;
  onThumbnail: () => void;
  onFilters: () => void;
  onMusic: () => void;
  onExport: () => void;
}

const Toolbar: React.FC<ToolbarProps> = ({
  aspectRatio, onAspectChange, onAddCaption, onAddEmoji,
  onAddImage, onThumbnail, onFilters,
  onMusic, onExport,
}) => {
  const [openMenu, setOpenMenu] = useState<string | null>(null);
  const toolbarRef = useRef<HTMLDivElement>(null);

  // Close dropdowns on outside click
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (toolbarRef.current && !toolbarRef.current.contains(e.target as Node)) {
        setOpenMenu(null);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const toggleMenu = (name: string) => setOpenMenu(prev => prev === name ? null : name);

  return (
    <div className="toolbar-panel" ref={toolbarRef}>
      <div className="toolbar-group">
        <button className="toolbar-btn" onClick={onAddCaption} title="Add a caption and open the Caption tab (C)">
          <span className="toolbar-icon">💬</span><span className="toolbar-label">Add Captions</span>
        </button>
        <button className="toolbar-btn" onClick={onAddEmoji} title="Add Emoji (E)">
          <span className="toolbar-icon">😀</span><span className="toolbar-label">Add Emojis</span>
        </button>
        <button className="toolbar-btn" onClick={onAddImage} title="Add Image (I)">
          <span className="toolbar-icon">🖼️</span><span className="toolbar-label">Add Image</span>
        </button>
        <button className="toolbar-btn" onClick={onThumbnail} title="Thumbnail">
          <span className="toolbar-icon">📷</span><span className="toolbar-label">Thumbnail</span>
        </button>
      </div>

      <div className="toolbar-divider" />

      <div className="toolbar-group">
        <div className="toolbar-dropdown-wrap">
          <button className="toolbar-btn" onClick={() => toggleMenu('aspect')} title="Aspect Ratio (A)">
            <span className="toolbar-icon">⬜</span><span className="toolbar-label">{aspectRatio} ▾</span>
          </button>
          {openMenu === 'aspect' && (
            <AspectDropdown currentRatio={aspectRatio} onSelect={onAspectChange} onClose={() => setOpenMenu(null)} />
          )}
        </div>
        <button className="toolbar-btn" onClick={onFilters} title="Filters (F)">
          <span className="toolbar-icon">🎨</span><span className="toolbar-label">Filters</span>
        </button>
        <button className="toolbar-btn" onClick={onMusic} title="Music (M)">
          <span className="toolbar-icon">🎵</span><span className="toolbar-label">Music</span>
        </button>
      </div>

      <div className="toolbar-divider" />

      <div className="toolbar-group">
        <button className="toolbar-btn toolbar-btn--export" onClick={onExport} title="Export Video">
          <span className="toolbar-icon">📤</span><span className="toolbar-label">Export</span>
        </button>
      </div>
    </div>
  );
};

export default Toolbar;
